import { gql } from "urql";
export const CreateOrganizationMutation = gql `
    mutation CreateOrganization(
        $name: String!
        $npiNumber: String!
        $about: String
        $email: String!
        $phoneNumber: String!
        $notes: String
        $insuranceIds: [String!]
        $imageKey: String
        $organizationTypes: [OrganizationTypesEnum!]
        $websiteUrl: String
        $imageVersion: String
        $therapyCategoryIds: [String!]
    ) {
        organizations {
            createOrganization(
                input: {
                    name: $name
                    npiNumber: $npiNumber
                    about: $about
                    email: $email
                    phoneNumber: $phoneNumber
                    notes: $notes
                    insuranceIds: $insuranceIds
                    websiteUrl: $websiteUrl
                    organizationTypes: $organizationTypes
                    imageKey: $imageKey
                    imageVersion: $imageVersion
                    therapyCategoryIds: $therapyCategoryIds
                }
            ) {
                organizationId
                npiNumber
                name
                email
                phoneNumber
                organizationTypes
                about
                notes
                imageUrl
                isActive
                createdAt
                updatedAt
                acceptedTermsConditionsAt
            }
        }
    }
`;
export const UpdateOrganizationMutation = gql `
    mutation UpdateOrganization(
        $organizationId: String!
        $name: String
        $npiNumber: String
        $email: String
        $phoneNumber: String
        $about: String
        $notes: String
        $insuranceIds: [String!]
        $organizationTypes: [OrganizationTypesEnum!]
        $websiteUrl: String
        $imageKey: String
        $imageVersion: String
        $therapyCategoryIds: [String!]
        $isActive: Boolean
    ) {
        organizations {
            updateOrganization(
                input: {
                    organizationId: $organizationId
                    name: $name
                    npiNumber: $npiNumber
                    about: $about
                    email: $email
                    notes: $notes
                    phoneNumber: $phoneNumber
                    insuranceIds: $insuranceIds
                    organizationTypes: $organizationTypes
                    websiteUrl: $websiteUrl
                    imageKey: $imageKey
                    imageVersion: $imageVersion
                    therapyCategoryIds: $therapyCategoryIds
                    isActive: $isActive
                }
            ) {
                organizationId
                npiNumber
                name
                email
                phoneNumber
                organizationTypes
                websiteUrl
                about
                notes
                imageUrl
                isActive
                createdAt
                updatedAt
                acceptedTermsConditionsAt
            }
        }
    }
`;
export const DeleteOrganizationMutation = gql `
    mutation DeleteOrganization($organizationId: String!) {
        organizations {
            deleteOrganization(organizationId: $organizationId) {
                organizationId
            }
        }
    }
`;
